// Layout.tsx - Layout principal estilo ITOBOX
import React, { ReactNode, useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import AccountStatusNotice from './AccountStatusNotice';
import InstallAppBanner from './InstallAppBanner';
import { useBrandColor } from './courier/CourierShell';
import './platformTheme.css';

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const brand = useBrandColor();

  return (
    <div className="flex min-h-screen bg-[#F5F6F8]">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Overlay para cerrar el menú en móvil/tablet al tocar fuera */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
          aria-hidden="true"
        />
      )}

      <div className="flex-1 flex flex-col lg:ml-[260px] transition-all min-w-0">
        <Header onMenuClick={() => setSidebarOpen(true)} />
        {/* .p2 = estilo ITOBOX Platform 2.0 para las pantallas (platformTheme.css) */}
        <main className="p2 flex-1 mt-16 p-3 sm:p-6 overflow-x-hidden" style={{ ['--p2-brand' as any]: brand }}>
          <AccountStatusNotice />
          <InstallAppBanner className="mb-4" />
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
